import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown, FaKey, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { UserAvatar } from '../../components/user/UserAvatar';
import { useCreatePasswordChangeTicketUrlMutation } from '../../graphql/hooks/useCreatePasswordChangeTicketUrlMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  isShrunk: boolean;
}

export const UserMenu = (props: Props) => {
  const { isShrunk } = props;

  const { user, organization } = useAppContext();
  const navigate = useNavigate();

  const resetPasswordMutation = useCreatePasswordChangeTicketUrlMutation();

  const resetPassword = async () => {
    const resp = await resetPasswordMutation.mutateAsync({ organizationId: organization.id });
    window.location.href = resp.createPasswordChangeTicketUrl;
  };

  const logout = () => {
    void navigate('/logout');
  };

  return (
    <ChakraV3.Menu.Root positioning={{ placement: 'right-end' }}>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='ghost' px={1} py={6} justifyContent='start' w='full'>
          <ChakraV3.HStack gap={2} fontSize='sm' overflow='hidden'>
            <UserAvatar
              secondary={user.email}
              picture={user.picture}
              name={user.name}
              w='28px'
              h='28px'
              showTooltip={false}
            />
            {!isShrunk && (
              <ChakraV3.Stack gap={1} lineHeight={1} align='start' overflow='hidden'>
                <ChakraV3.Text fontWeight='semibold'>{user.name}</ChakraV3.Text>
                <ChakraV3.Text color='secondary' fontSize='xs' fontWeight='normal'>
                  {user.email}
                </ChakraV3.Text>
              </ChakraV3.Stack>
            )}
          </ChakraV3.HStack>
          {!isShrunk && <FaAngleDown />}
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={resetPassword}
            data-pw='resetPasswordMenuItem'
            value='reset-password'
            fontSize='md'
          >
            <FaKey />
            Reset password
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem onClick={logout} value='logout' fontSize='md'>
            <FaSignOutAlt />
            Logout
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
